var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "card",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-body",
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "3",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.slugList,
                          "item-text": "name",
                          "item-value": "slug",
                          label: "เลือกประเภทเกมส์",
                          outlined: "",
                        },
                        on: {
                          change: _vm.getGameLists,
                        },
                        model: {
                          value: _vm.query.slugAdd,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "slugAdd", $$v)
                          },
                          expression: "query.slugAdd",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "4",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.gameList,
                          "item-text": "name",
                          "item-value": "id",
                          label: "เลือกรอบเกมส์",
                          outlined: "",
                        },
                        model: {
                          value: _vm.query.gameId,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "gameId", $$v)
                          },
                          expression: "query.gameId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "3",
                      },
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          align: "center",
                          label: "กรอกเลข5หลัก",
                          outlined: "",
                          pattern: "\\d{5,5}",
                          maxlength: "5",
                          min: "5",
                          required: "",
                        },
                        on: {
                          keypress: function ($event) {
                            return _vm.validateNumber($event)
                          },
                        },
                        model: {
                          value: _vm.result,
                          callback: function ($$v) {
                            _vm.result = $$v
                          },
                          expression: "result",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "2",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            large: "",
                          },
                          on: {
                            click: _vm.addResult,
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("mdi-plus")]),
                          _vm._v("\n            เพิ่ม\n          "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "info",
                            large: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.displayDigits()
                            },
                          },
                        },
                        [
                          _c("v-icon", [_vm._v("mdi-digit")]),
                          _vm._v("\n            ดูเลข\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card mt-5",
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "card-body",
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "5",
                      },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.slugList,
                          "item-text": "name",
                          "item-value": "slug",
                          label: "เลือกประเภทเกมส์",
                          outlined: "",
                        },
                        model: {
                          value: _vm.query.slug,
                          callback: function ($$v) {
                            _vm.$set(_vm.query, "slug", $$v)
                          },
                          expression: "query.slug",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "5",
                      },
                    },
                    [
                      _c(
                        "v-menu",
                        {
                          ref: "showDateDialog",
                          attrs: {
                            "close-on-content-click": false,
                            "return-value": _vm.dateSelect,
                            transition: "scale-transition",
                            "offset-y": "",
                            "min-width": "auto",
                          },
                          on: {
                            "update:returnValue": function ($event) {
                              _vm.dateSelect = $event
                            },
                            "update:return-value": function ($event) {
                              _vm.dateSelect = $event
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (_ref) {
                                var on = _ref.on,
                                  attrs = _ref.attrs
                                return [
                                  _c(
                                    "v-text-field",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            label: "วันที่",
                                            outlined: "",
                                          },
                                          model: {
                                            value: _vm.dateSelectDisplay,
                                            callback: function ($$v) {
                                              _vm.dateSelectDisplay = $$v
                                            },
                                            expression: "dateSelectDisplay",
                                          },
                                        },
                                        "v-text-field",
                                        attrs,
                                        false
                                      ),
                                      on
                                    )
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.showDateDialog,
                            callback: function ($$v) {
                              _vm.showDateDialog = $$v
                            },
                            expression: "showDateDialog",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c("v-date-picker", {
                            attrs: {
                              "no-title": "",
                            },
                            on: {
                              change: function ($event) {
                                _vm.$refs.showDateDialog.save(
                                  _vm.dateSelectDisplay
                                )
                                _vm.showDateDialog = false
                              },
                            },
                            model: {
                              value: _vm.dateSelect,
                              callback: function ($$v) {
                                _vm.dateSelect = $$v
                              },
                              expression: "dateSelect",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        sm: "2",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            large: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData(_vm.query.slug)
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                              },
                            },
                            [_vm._v("\n              mdi-check\n            ")]
                          ),
                          _vm._v("\n            ค้นหา\n          "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-0",
                attrs: {
                  "footer-props": _vm.footer,
                  headers: _vm.headers,
                  items: _vm.items,
                  loading: _vm.loading,
                  "multi-sort": false,
                  options: _vm.options,
                  "server-items-length": _vm.totalItems,
                  "item-key": "id",
                },
                on: {
                  "update:items": function ($event) {
                    _vm.items = $event
                  },
                  "update:options": function ($event) {
                    _vm.options = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.game_name",
                    fn: function (_ref2) {
                      var item = _ref2.item
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "/admin/lotto/approve/" + item.id,
                              target: "blank",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-danger",
                              },
                              [
                                _vm._v(
                                  _vm._s(item.master.name) +
                                    " " +
                                    _vm._s(item.readable_edition) +
                                    "\n            " +
                                    _vm._s(item.game_thai_date)
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.status",
                    fn: function (_ref3) {
                      var item = _ref3.item
                      return [
                        item.status == "open"
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  color: "green",
                                  outlined: "",
                                },
                              },
                              [_vm._v("\n            เปิดรับแทง\n          ")]
                            )
                          : item.status == "pending"
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  color: "blue",
                                  outlined: "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            เกมส์ยังไม่เปิด\n          "
                                ),
                              ]
                            )
                          : _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  color: "red",
                                  outlined: "",
                                },
                              },
                              [_vm._v("\n            เกมส์จบแล้ว\n          ")]
                            ),
                      ]
                    },
                  },
                  {
                    key: "item.result",
                    fn: function (_ref4) {
                      var item = _ref4.item
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              item.result_limit
                                ? item.result_limit.digits
                                : "ไม่มีการล็อคผล"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.user",
                    fn: function (_ref5) {
                      var item = _ref5.item
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.result_limit.user.name) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.created_at",
                    fn: function (_ref6) {
                      var item = _ref6.item
                      return [
                        item.created_at
                          ? _c(
                              "span",
                              {
                                staticClass: "d-block",
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(item.created_at) +
                                    "\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.manage",
                    fn: function (_ref7) {
                      var item = _ref7.item
                      return [
                        (_vm.$moment().valueOf() -
                          _vm.$moment(item.close_at).valueOf()) /
                          1000 <
                        30
                          ? _c(
                              "div",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "warning",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.delResult(item.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", [_vm._v("mdi-delete")]),
                                    _vm._v("\n              ลบ\n            "),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            "max-width": "100vw",
            persistent: "",
          },
          model: {
            value: _vm.digitsItem,
            callback: function ($$v) {
              _vm.digitsItem = $$v
            },
            expression: "digitsItem",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "red",
                    height: "55",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "pa-0",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-body-1 text-uppercase text-light",
                        },
                        [_vm._v("ดูเลข")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.closeDialog()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex text-md font-weight-bold py-1 border-top bg-black text-white",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-center border-right",
                      staticStyle: {
                        width: "40%",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text-monospace",
                        },
                        [_vm._v("\n            เลข\n          ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-center border-right",
                      staticStyle: {
                        width: "30%",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text-monospace",
                        },
                        [_vm._v("\n            ยอดแทง\n          ")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-center",
                      staticStyle: {
                        width: "30%",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "text-monospace",
                        },
                        [_vm._v("\n            จ่าย\n          ")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.digitsList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex text-lg py-1 border-top",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "border-right",
                            staticStyle: {
                              width: "40%",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text-center text-md",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.digits) +
                                    "\n              "
                                ),
                                _c("span", [
                                  _c("i", {
                                    class: _vm.iconType(item.slug),
                                  }),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "border-right",
                            staticStyle: {
                              width: "30%",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text-center text-md",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      Intl.NumberFormat("en-US").format(
                                        item.amount
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "30%",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text-center text-md",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      Intl.NumberFormat("en-US").format(
                                        item.prize
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "card-header",
      },
      [_c("h2", [_vm._v("ล็อคผล")])]
    )
  } /* staticRenderFnsSpliter */,
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "card-header",
      },
      [_c("h2", [_vm._v("เช็คผลล็อค")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }